'use strict';

var ajax = require('../../ajax'),
	progress = require('../../progress'),
	cart = require('../cart'),
	linchpinCheckout = require('int_googletagmanager/linchpin/checkoutInfo'),
	optinout = require('../../optinout');

exports.init = function () {
	$('.submit-order #continue-shopping').on('click', function () {
		window.PoqWebCheckout.send('closewebview');
	});

	if ($('#secure-acceptance-summary-form').length) {
		$('#secure-acceptance-summary-submit').on('click', function (e) {
			if ($('#secure-acceptance-summary-submit').data('stock-check') === true) {
				return;
			}
			e.preventDefault();
			progress.show($(this).parents('.form-row'));
			ajax.getJson({
				url: Urls.validateCartForCheckout,
				callback: function (data) {
					if (!data || !data.success) {
						location.reload();
					} else {
						$('#secure-acceptance-summary-submit').data('stock-check', true);
						$('#secure-acceptance-summary-submit').trigger('click');
					}
				}
			});
		});
		$('.secondary-submit').on('click', function () {
			$('#secure-acceptance-summary-submit').trigger('click');
			progress.show($(this).parents('.second-submit'));
		});
	}
	// toggling components of Build a box bundle
	cart.toggleBaBComponents();

	optinout.init();

	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		// track info as all shipping and payment info was submitted
		linchpinCheckout.paymentInfoEvent();
		linchpinCheckout.shippingInfoEvent();
	}
};
